// extracted by mini-css-extract-plugin
export var banner = "_iq-0";
export var closeButton = "_iq-2";
export var greenCheckmark = "_iq-3";
export var hereLink = "_iq-4";
export var titleIcon = "_iq-1";